<template>
  <sfs-form-modal
    :id="modalId"
    title="Add a Compliance Document"
    size="lg"
    @on-hide="resetFormData"
  >
    <compliance-document-form
      @on-submit="create"
      @on-save="redirectToCertificate"
      @on-cancel="closeModal"
      :key="formKey"
      :reminder_days="0"
      :reminder-frequency-options="reminderFrequencyOptions"
      :category-options="categoryOptions"
      :document-type-options="documentTypeOptions"
    />
  </sfs-form-modal>
</template>

<script>
import ComplianceDocumentForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'ComplianceDocumentAddModal',
  mixins: [formModalMixin],
  components: {
    ComplianceDocumentForm,
  },
  props: {
    locationId: Number,
  },
  data() {
    return {
      reminderFrequencyOptions: [],
      categoryOptions: [],
      documentTypeOptions: [],
      modalId: 'compliance-document-add-modal',
    };
  },
  mounted() {
    this.getReminderFrequencyOptions();
    this.getCategoryOptions();
    this.getDocumentTypeOptions();
  },
  methods: {
    getReminderFrequencyOptions() {
      this.$complianceDocumentsAPI.getReminderFrequencyOptions().then((response) => {
        this.reminderFrequencyOptions = response.data.reminder_frequency_options.map((option) => {
          return { label: option[0], value: option[1] };
        });
      });
    },
    getCategoryOptions() {
      this.$store.cache.dispatch('getComplianceDocumentCategories').then((options) => {
        this.categoryOptions = options.map((option) => {
          return { label: option[0], value: option[1] };
        });
      });
    },
    getDocumentTypeOptions() {
      this.$store.cache.dispatch('getComplianceDocumentDocumentTypes').then((options) => {
        this.documentTypeOptions = options.map((option) => {
          return { label: option[0], value: option[1] };
        });
      });
    },
    create(data, handleCreate) {
      handleCreate(this.$complianceDocumentsAPI.create(data.user_id, data));
    },
    redirectToCertificate(complianceDocument) {
      this.$router.push({ name: 'compliance-document', params: { id: complianceDocument.id } });
    },
  },
};
</script>
